import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import RedirectContainer from "../../../components/RedirectContainer";
import SidebarPanelNavigation from "../../../components/SidebarPanelNavigation";
import LoadingIndicator from "../../../components/LoadingIndicator";
import useNotification from "../../../contexts/notification";
import { getThemeSettings, updateThemeSettings } from "../../../services/api";
import { applyThemeVariables } from "../../../utils/theme";

const DEFAULT_COLORS = {
    primary: "#000000",
    success: "#000000",
};

export default function ThemeSettings() {
    const [colors, setColors] = useState(DEFAULT_COLORS);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const { setMessage } = useNotification();

    useEffect(() => {
        getThemeSettings().then(
            (response) => {
                if (response?.data) {
                    setColors(response.data);
                    applyThemeVariables(response.data);
                }
                setLoading(false);
            },
            () => {
                setLoading(false);
                setMessage({
                    error: true,
                    content: "Não foi possível carregar as cores do tema.",
                });
            }
        );
    }, [setMessage]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setColors((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSaving(true);

        try {
            const response = await updateThemeSettings(colors);
            if (response?.data) {
                setColors(response.data);
                applyThemeVariables(response.data);
            }
            setMessage({
                error: false,
                content: "Tema atualizado com sucesso.",
            });
        } catch (error) {
            setMessage({
                error: true,
                content: "Não foi possível salvar o tema. Tente novamente.",
            });
        } finally {
            setSaving(false);
        }
    };

    return (
        <RedirectContainer role="admin">
            <Container fluid>
                <SidebarPanelNavigation isAdmin />
                <div className="content-panel">
                    {loading && <LoadingIndicator />}
                    {!loading && (
                        <Row className="mt-3">
                            <Col lg={6}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className="text-primary">
                                            Personalização de Cores
                                        </Card.Title>
                                        <Card.Text>
                                            Atualize as cores principais do aplicativo e veja a
                                            mudança aplicada imediatamente.
                                        </Card.Text>
                                        <Form onSubmit={handleSubmit}>
                                            <Form.Group controlId="themePrimary">
                                                <Form.Label>Cor primária</Form.Label>
                                                <Form.Control
                                                    type="color"
                                                    name="primary"
                                                    value={colors.primary}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                            <Form.Group controlId="themeSuccess" className="mt-3">
                                                <Form.Label>Cor de destaque (success)</Form.Label>
                                                <Form.Control
                                                    type="color"
                                                    name="success"
                                                    value={colors.success}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                            <Button
                                                className="mt-3"
                                                type="submit"
                                                disabled={saving}
                                            >
                                                {saving ? "Salvando..." : "Salvar alterações"}
                                            </Button>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col lg={6} className="mt-3 mt-lg-0">
                                <Card>
                                    <Card.Body>
                                        <Card.Title className="text-primary">
                                            Pré-visualização
                                        </Card.Title>
                                        <Card.Text>
                                            Exemplo de botões e destaques com as cores atuais.
                                        </Card.Text>
                                        <div className="d-flex flex-column gap-2">
                                            <Button variant="primary" className="mb-2">
                                                Botão primário
                                            </Button>
                                            <Button variant="success" className="mb-2">
                                                Botão success
                                            </Button>
                                            <span className="text-primary">
                                                Texto primário de exemplo
                                            </span>
                                            <span className="text-success">
                                                Texto success de exemplo
                                            </span>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                </div>
            </Container>
        </RedirectContainer>
    );
}